import { Table } from 'react-bootstrap';
import { IManagingWebSitesInstance } from '../../api/models';
import { Checkbox } from '../../areas/app/Checkbox';
import { WebSiteAction } from '../../constants/WebSiteAction';
import { ScopedUserPrincipal } from '../../permissions/ScopedUserPrincipal';
import { UserPrincipal } from '../../permissions/userPrincipal';
import { ServerApplicationClientEventSummary } from '../../signalr/models';
import { EmptyDataRow } from '../UIExtentions/TableUtilities';
import { WebSiteActionHandlerProps } from './WebSitesServerManagementView';
import { WebSitesServerRow } from './WebSitesServerRow';

interface ApplicationServerTableProps {
    userPrincipal: UserPrincipal;
    serversUserPrincipal: ScopedUserPrincipal;
    allServersSelectionChanged: (selected: boolean) => void;
    serverSelectionChanged: (selected: boolean, serverName: string) => void;
    onClickCallback: (props: WebSiteActionHandlerProps) => Promise<void>;
    serverApps: IManagingWebSitesInstance[];
    servers: string[];
    allSelected: boolean;
    onTimeoutCallback: (data: ServerApplicationClientEventSummary) => void;
}
export const WebSitesServerTable = ({
    userPrincipal,
    serversUserPrincipal,
    allServersSelectionChanged,
    serverSelectionChanged,
    onClickCallback,
    serverApps,
    servers,
    allSelected,
    onTimeoutCallback,
}: ApplicationServerTableProps) => {
    return (
        <Table striped size="sm">
            <thead>
                <tr>
                    <th scope="col" className="col-1">
                        <Checkbox selected={allSelected} selectionChangedCallback={allServersSelectionChanged} />
                    </th>
                    <th scope="col" className="col-4">
                        Name
                    </th>
                    <th scope="col" className="col-1">
                        Env.
                    </th>
                    <th scope="col" className="col-1">
                        Status
                    </th>
                    <th scope="col" className="col-1">
                        Refresh
                    </th>
                    <th scope="col" className="col-3"></th>
                    <th scope="col" className="col-3 text-center">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                {serverApps !== null && serverApps.length > 0 ? (
                    serverApps.map(function (serverApp: IManagingWebSitesInstance) {
                        const selected = servers.includes(serverApp.serverName);
                        return (
                            <WebSitesServerRow
                                serverApp={serverApp}
                                key={serverApp.serverId}
                                selected={selected}
                                userPrincipal={userPrincipal}
                                serverUserPrincipal={serversUserPrincipal?.getUserPrincipal(serverApp.serverName)}
                                selectionChangedCallback={serverSelectionChanged}
                                onClickCallback={(action: WebSiteAction) =>
                                    onClickCallback({
                                        webSiteName: serverApp.name,
                                        servers: [serverApp.serverName],
                                        action: action,
                                    })
                                }
                                onTimeoutCallback={onTimeoutCallback}
                            />
                        );
                    })
                ) : (
                    <EmptyDataRow colSpan={7} />
                )}
            </tbody>
        </Table>
    );
};
